<template>
  <section class="py-6">
    <slot></slot>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
